export default __webpack_public_path__ + "static/media/aboutBG.7df390cd.webp";